export default {
  homeRow1: '加速您的数字化转型',
  homeRow2: '',
  homeRow3: '',
  homeRow4: '联接您的价值链',
  homeRow5: '丰富您的客户体验',
  homeRow6: '帮助您更快更优决策',
  homeRow7: '杰为是国内唯一一家十年以上既有工业经验又有软件开发专长的软件公司,',
  homeRow8: '',
  homeRow9: '同时又是被广泛证明有能力去帮助中国企业消除对国外软件供应商依赖的中国软件供应商。',
  homeRow10: '',
  homeRow11: '',
  homeRow12: '自行决定数字转化优先级的云原生平台，不受PLM供应商制约。新应用与现有系统同时运行，以合适节奏替换当前软件，促进业务发展。',
  homeRow13: '',
  homeRow14: '',
  homeRow15: '了解更多',
  homeRow16: '提交',
  homeRow17: '数字化转型，全速启动',
  homeRow18: '',
  homeRow19: '如果您计划在产品开发进程中投入全新的数字应用，或者想要证明某种创新方式，请给我们留言，我们会安排杰为解决方案专家与您沟通。',
  homeRow20: '',
  homeRow21: '',
  homeRow22: '我希望 *',
  homeRow23: '名字 *',
  homeRow24: '邮箱 *',
  homeRow25: '公司',
  homeRow26: '联系',
  homeRow27: '工作',
  homeRow28: '消息/问题',
  homeRow29: '必填',
  homeRow30: '加入杰为'
}
